var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSeatButtonUnavailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 40,
  viewBox: "0 0 36 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.8469 5.93762V5.93765H10.8538L25.1465 5.93767L25.1533 5.93762C26.3702 5.92878 27.5439 6.38821 28.4315 7.22078C29.3128 8.04758 29.8449 9.17948 29.9197 10.385V22.1429C29.9197 28.7259 24.5831 34.0625 18.0001 34.0625C11.4171 34.0625 6.08056 28.7259 6.08056 22.1429V10.385C6.15534 9.17949 6.68747 8.04758 7.56884 7.22078C8.45637 6.38821 9.63006 5.92878 10.8469 5.93762Z",
  fill: "white",
  stroke: "#8C8C8C",
  strokeWidth: 1.87499
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4447 25.4437L12.5566 14.5557",
  stroke: "#8C8C8C",
  strokeWidth: 0.937495,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4447 14.5557L12.5566 25.4437",
  stroke: "#8C8C8C",
  strokeWidth: 0.937495,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgSeatButtonUnavailable as ReactComponent };